export default __webpack_public_path__ + "static/media/100_51340.c2e5ad8f.jpg";